import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { v4 as uuidv4 } from 'uuid';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#007839",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const DialogTable = ({
  showPopup,
  closeBtnHanlder,
  popupTitle,
  closeBtnText,
  noResultMessage,
  tableData = [],
  tableHeadingList = [],
  valueToRenderKeyList = [],
}) => {
  const useStyles = makeStyles({
    topScrollPaper: {
      alignItems: "flex-start",
    },
    topPaperScrollBody: {
      verticalAlign: "top",
    },
  });
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
 
  const handleChangeTablePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Dialog
      className="nationalDialog"
      open={showPopup}
      onClose={closeBtnHanlder}
      aria-labelledby="view-national-providers-dialog"
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-root": {
          overflowY: "scroll !important",
        },
        "& .MuiDialog-container": {
          marginTop: "75rem",
          marginBottom: "55rem",
          height: "100vh !important",
        },
        "& .MuiDialog-paper": {
          maxHeight: "max-content !important",
          marginTop: "5rem",
          overflowY: "visible",
        },
      }}
      classes={{
        scrollPaper: classes.topScrollPaper,
        paperScrollBody: classes.topPaperScrollBody,
      }}
    >
      <DialogTitle
        sx={{ fontWeight: "bold", position: "relative" }}
        id="view-national-providers-dialog"
      >
        <h3> {popupTitle} </h3>
        <IconButton
          edge="end"
          color="green"
          onClick={closeBtnHanlder}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon sx={{ color: "green" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          paddingLeft: "25px",
          paddingRight: "25px",
        }}
      >
        {tableData === null || tableData?.length == 0 ? (
          <div>{noResultMessage} </div>
        ) : (
          <div className="providersTable">
            <Paper>
              <TableContainer component={Paper}>
                <Table
                  aria-label="National-or-regional-provider-table"
                  size="small"
                >
                  <TableHead>
                    <TableRow>
                      {tableHeadingList.map((tableHeading) => (
                        <StyledTableCell
                          key={tableHeading}
                          align="left"
                          width="20%"
                          style={{ borderRight: "2px solid white" }}
                        >
                          {tableHeading}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData?.length > 0 &&
                      tableData
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                          <StyledTableRow
                            key={`row${uuidv4()}`}
                          >
                            {valueToRenderKeyList.map(
                              (data) =>
                                row?.[data] && (
                                  <StyledTableCell
                                    key={`cell_${uuidv4()}_${uuidv4()}`}
                                    align="left"
                                    width="20%"
                                    style={{
                                      borderRight: "1px solid #f2f2f599",
                                    }}
                                  >
                                    {row[data]}
                                  </StyledTableCell>
                                )
                            )}
                          </StyledTableRow>
                        ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[25, 50, 75, 100]}
                component="div"
                count={tableData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangeTablePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          data-testid="closeBtn"
          color="primary"
          sx={{ textTransform: "initial", borderRadius: "0px !important" }}
          onClick={closeBtnHanlder}
          className="font16"
        >
          {closeBtnText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogTable.propTypes = {
  showPopup: PropTypes.boolean,
  closeBtnHanlder: PropTypes.func.isRequired,
  popupTitle: PropTypes.string,
  closeBtnText: PropTypes.string,
  noResultMessage: PropTypes.string.isRequired,
  tableData: PropTypes.array.isRequired,
  tableHeadingList: PropTypes.array,
  valueToRenderKeyList: PropTypes.array.isRequired,
};

export default DialogTable;
